import { h } from "preact";
import { useEffect } from "preact/hooks";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Hint from "./Hint.jsx";

import emailApi from "../api/email";
import hintApi from "../api/hint";
import {
  fetchCurrentHint,
  setCurrentHint,
  setCurrentHintDisabled,
  setCurrentHintState,
  setShowWaitingListModal,
} from "../store";

export default function HintContainer({ page }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentHint = useSelector((state) => state.hints.hint);
  const currentHintState = useSelector((state) => state.hints.currentHintState);
  const currentHintDisabled = useSelector(
    (state) => state.hints.currentHintDisabled
  );

  async function handleAction(action) {
    switch (action.type) {
      case "confirm_email":
        dispatch(setCurrentHintState("sending"));
        try {
          await emailApi.resend_confirmation();
        } catch (err) {
          // We can ignore this, erros are logged in backend
        }
        dispatch(setCurrentHintState("done"));
        break;
      case "link_and_seen":
        navigate(action.path);
        await hintApi.markAsSeen(currentHint.id);
        break;
      case "open_task":
        navigate(`/tasks/${encodeURIComponent(action.taskId)}`);
        break;
      case "link":
        navigate(action.to);
        break;
      case "waiting_list":
        dispatch(setShowWaitingListModal(true));
        break;
      case "sign_up":
        hintApi.markAsSeen(currentHint.id);
        window.location.href = "/register";
        break;
      case "mark_as_seen":
        dispatch(setCurrentHintState("sending"));
        await hintApi.markAsSeen(currentHint.id);
        dispatch(setCurrentHintState("done"));
        dispatch(fetchCurrentHint(page));
        break;
      case "employer_request_accept":
        dispatch(setCurrentHintDisabled(true));
        await hintApi.changeTalentStateState(
          currentHint.extraData.talentStateId,
          "request_accepted"
        );
        dispatch(setCurrentHintDisabled(false));
        dispatch(
          setCurrentHint({
            color: "success",
            icon: "hint_reply_sent",
            id: "employer_request_accepted",
            placeholders: currentHint.placeholders,
            action: { type: "get_new" },
          })
        );
        break;
      case "employer_request_decline":
        dispatch(setCurrentHintDisabled(true));
        await hintApi.changeTalentStateState(
          currentHint.extraData.talentStateId,
          "request_declined"
        );
        dispatch(setCurrentHintDisabled(false));
        dispatch(
          setCurrentHint({
            color: "success",
            icon: "hint_reply_sent",
            id: "employer_request_declined",
            placeholders: currentHint.placeholders,
            action: { type: "get_new" },
          })
        );
        break;
      case "get_new":
        dispatch(fetchCurrentHint(page));
        break;
      default:
        throw new Error(`Action ${action.type} not implemented.`);
    }
  }

  useEffect(() => {
    dispatch(fetchCurrentHint(page));
  }, []);

  return currentHint ? (
    <Hint
      hint={currentHint}
      onAction={handleAction}
      disabled={currentHintDisabled}
      currentHintState={currentHintState}
    />
  ) : null;
}
